import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import bem from '../../../common/bem'

import './InputText.scss'
export default class InputText extends Component {

  constructor() {
    super()
  }


  render() {

    const { className, placeholder, defaultValue, isSearch, onChange } = this.props
    let bemmer = bem('inputtext')
    let outerBemmer = bemmer.element('container')
    outerBemmer = isSearch ? outerBemmer.modifier('with-search') : outerBemmer

    return (
      <div className={outerBemmer.withClass(className)}>
        <input
          onChange={onChange ? onChange.bind(this) : null}
          className={bemmer.element('input')}
          defaultValue={defaultValue}
          placeholder={placeholder}/>
      </div>
    )
  }
}

InputText.defaultProps = {
  className: '',
  isSearch: false
}

InputText.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func
}



// WEBPACK FOOTER //
// ./component/ui/InputText/InputText.js